/*优秀企业家申报*/

//----------------------------------------------登录之后

/*获取已申报项目明细*/
export function getApplyList_Apply(config) {
   config.method = 'get'
   config.url = '/project/PaBasicMsgEntrepreneurVy/selectForApply'
   apiRequest(config)
}

/*获取已申报项目明细*/
export function getApplyList_Recom(config) {
   config.method = 'get'
   config.url = '/project/PaBasicMsgEntrepreneurVy/selectForRecom'
   apiRequest(config)
}

//--------------------------------------申报基本数据

/*获取申报项目的基本信息*/
import {apiRequest} from "@/api/api";

export function getApplyBasicInfo(config) {
   config.method = 'get'
   config.url = '/project/PaBasicMsgEntrepreneur/getApplyBasicInfo'
   apiRequest(config)
}

/*提交申报基本信息*/
export function postApplyBasicInfo(config) {
   config.method = 'post'
   config.formData = true
   config.url = '/project/PaBasicMsgEntrepreneur/postApplyBasicInfo'
   apiRequest(config)
}